var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-player"},[_c('div',{staticClass:"video-img"},[_c('img',{directives:[{name:"img-auto",rawName:"v-img-auto"}],attrs:{"src":_vm.data.img_src}})]),_vm._v(" "),_c('i',{staticClass:"play-btn iconfont"},[_vm._v("")]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b742114","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageEditor/modules/videoPlayer.vue
// module id = null
// module chunks = 